<template>
  <div>
    <div class="mb-6">
      <v-btn text :to="{ name: 'Produits', query: { ...$route.query } }"
        ><v-icon>mdi-arrow-left</v-icon> {{ $t("boutique.retourALaBoutique") }}</v-btn
      >
    </div>

    <template v-if="!commandeFinalisee && !commandeEchec">
      <h2 class="mb-2 mb-md-6 display-1">{{ $t("boutique.contenuDuPanier") }}</h2>
      <Panier />

      <template v-if="panier.length > 0">
        <div class="text-right">
          <v-btn text small color="error" @click="VIDER_PANIER"
            ><v-icon small class="mr-2">mdi-delete</v-icon>{{ $t("boutique.viderLePanier") }}</v-btn
          >
        </div>
        <v-divider class="my-6"></v-divider>

        <InformationsAchat ref="informationsAchat" class="mb-6" />

        <h2 class="mb-2 display-1">{{ $t("boutique.modePaiement") }}</h2>

        <v-form ref="paiementForm">
          <v-row>
            <v-col cols="12" md="6" class="pb-0">
              <v-autocomplete :items="listeModePaiement" v-model="modePaiement" outlined :item-text="$i18n.locale" item-value="id" :rules="required">
                <template v-slot:label>{{ $t("boutique.modePaiement") }} *</template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn block x-large v-if="showBoutonPaiement" :loading="loading" color="primary" @click="creerBoutique">
                {{ $t("boutique.finaliser") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </template>
    </template>
    <template v-if="commandeFinalisee">
      <v-alert dense text type="success">
        {{ $t("boutique.messageSucces") + this.idFacturation }}
      </v-alert>
    </template>
    <template v-if="commandeEchec">
      <v-alert dense outlined type="error">
        {{ $t("boutique.messageError") }}
      </v-alert>
    </template>
  </div>
</template>

<script>
import Panier from "@/components/boutique/Panier"
import InformationsAchat from "@/components/boutique/InformationsAchat"
import { Api } from "@/plugins/api"
import { mapActions, mapGetters } from "vuex"
import Rules from "@/mixins/Rules"
import PaysafeModale from "@/mixins/PaysafeModale"
export default {
  mixins: [Rules, PaysafeModale],
  components: {
    Panier,
    InformationsAchat,
    PaysafeModale
  },
  data() {
    return {
      boutique: {},
      paiement: false,
      showBoutonPaiement: true,
      idFacturation: "",
      loading: false,
      commandeFinalisee: false,
      commandeEchec: false,
      typePaiement: 0,
      modePaiement: 0,
      listeModePaiement: [
        { id: 1, fr: "Carte de crédit", en: "Credit card" },
        { id: 2, fr: "Précommande (exclusif aux institutions de la santé)", en: "Pre-order (exclusive to health institutions)" }
      ]
    }
  },
  computed: {
    ...mapGetters(["panier", "account", "loggedIn", "total"])
  },
  methods: {
    ...mapActions(["VIDER_PANIER"]),

    async creerBoutique() {
      if (!this.$refs.informationsAchat.$refs.mainForm.validate() | !this.$refs.paiementForm.validate()) {
        return
      }
      this.loading = true

      this.boutique = {
        articles: this.panier,
        ppId: this.account.id,
        adresse: this.account.adresse.adresse,
        civilite: this.account.civilite.id,
        codePostal: this.account.adresse.codePostal,
        courriel: this.account.courriel,
        nom: this.account.nom,
        prenom: this.account.prenom,
        province: this.account.adresse.province.id,
        telephone: this.account.adresse.telephone,
        telephoneAuTravail: this.account.adresse.telTravail,
        ville: this.account.adresse.ville,
        langue: this.$i18n.locale
      }

      if (this.modePaiement == 2) {
        Api.post("boutiques/precommande", this.boutique)
          .then((res) => {
            this.idFacturation = res.data.numero
            this.commandeFinalisee = true
            this.VIDER_PANIER()
          })
          .catch((res) => {
            this.commandeEchec = true
          })
          .finally(() => {})
      } else {
        this.showPaysafeModale(this.total.total, `${this.account.prenom} ${this.account.nom}`)
      }
    },
    onCloseBeforePayment() {
      this.loading = false
    },
    onSuccessPaysafe(token) {
      this.boutique.paymentToken = token
      Api.post("transactions", this.boutique)
        .then((res) => {
          if (res.data.paiementReussi === true) {
            this.showMessageSuccessPaiement(res.data.idBoutique)
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMessageEchecPaiement()
        })
    },
    showMessageSuccessPaiement(num) {
      this.idFacturation = num
      this.commandeFinalisee = true
      this.paiement = false
      this.showBoutonPaiement = false
      this.VIDER_PANIER()
    },
    showMessageEchecPaiement() {
      this.commandeEchec = true
      this.loading = false
      this.showBoutonPaiement = true
    }
  }
}
</script>
